import { ScenarioTypes } from "constant";

/**
 * demande de récupération des transactions
 */
export function fetchTransaction() {
  return {
    type: ScenarioTypes.FETCH_TRANSACTION
  };
}

/**
 * Demande de récupérations des transactions valide
 * @param params paramètre récupéré
 */
export function fetchTransactionSuccess(params: any) {
  return {
    type: ScenarioTypes.FETCH_TRANSACTION_SUCCESS,
    payload: { params }
  };
}

/**
 * récupération des transactions invalide
 */
export function fetchTransactionError() {
  return {
    type: ScenarioTypes.FETCH_TRANSACTION_ERROR
  };
}
